module.exports = __webpack_public_path__ + "assets/img/page3-design-base-17233eff.jpg";